// extracted by mini-css-extract-plugin
export default {"home":"Home_home__hv-0c","title":"Home_title__Y-lH7","logo":"Home_logo__hworU","content":"Home_content__hbamP"};